import React, { Component } from 'react';
import 
  APP_CONSTANTS, 
  { DATA_OBJECT_TYPES } 
from '../shared/constants/app_constants';

class HTMLExpressionEditor extends Component {
  htmlEditorId = "html-editor-textarea"; 

  // TODO: prevent save when textarea contains script or style tag
  constructor(props){
    super(props); 
    this.state = {
      editorContent: props.form_rule.nocode_expression || ' ',
    };
    this.textareaRef = React.createRef();
  }

  addValueTypeToExpression = (valueType) => {
    // TODO: get selection of TEXTAREA, insert param in correct place
    const textArea = this.textareaRef.current;

    let newTextAreaValue;
    let faName = `${valueType.name}`;
    if (valueType.object_type === 'metadata_type') {
      faName = `${valueType.form_attribute_name}.${valueType.name}`;
    }
    const formAttributeNameParam = `{{${faName}}}`;
    if (textArea.selectionStart === textArea.selectionEnd) {
      if (textArea.value.length === textArea.selectionStart) { // append to end
        newTextAreaValue = textArea.value + formAttributeNameParam;
      } else {  // insert at specific location
        newTextAreaValue = (textArea.value.slice(0, textArea.selectionStart) 
          + formAttributeNameParam + textArea.value.slice(textArea.selectionStart) );
      }
    } else {
      newTextAreaValue = (textArea.value.slice(0, textArea.selectionStart) 
      + formAttributeNameParam + textArea.value.slice(textArea.selectionEnd) );
    }
    this.setState({
      editorContent: newTextAreaValue
    });
  }

  clearEditorContent = () => {
    this.setState({ editorContent: "" });
  }

  componentDidMount() {
    const textArea = this.textareaRef.current;
    const contentValue = textArea.value;
    textArea.selectionStart = textArea.selectionEnd = contentValue.length;
  }

  getEligbleFormAttributesForEditor = () => {
    //this depends on the target attribute
    let eligbleDataItems = [];
    this.props.keenform.form_attributes.forEach((fa) => {
      const formAttribute = {
        ...fa,
        object_type: 'form_attribute',
        form_attribute_id: fa.id
      };
      if ( formAttribute.form_attribute_type !== APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.INLINE_STYLE ){
        eligbleDataItems.push(formAttribute);
      }
      if (fa.metadata_types){
        fa.metadata_types.forEach(mdt => {
          // TODO: this code smells
          const metadataTypeAsFA = {
            ...mdt,
            label: `${fa.name}.${mdt.name}`,
            object_type: DATA_OBJECT_TYPES.METADATA_TYPE,
            fa_uuid: fa.uuid,
            form_attribute_name: fa.name,
            form_attribute_display_type: fa.display_type,
            form_attribute_id: fa.id
          };
          eligbleDataItems.push(metadataTypeAsFA);
        })
      }
    });
    return eligbleDataItems;
  }

  updateTextarea = (event) => {
    this.setState({ editorContent: event.target.value });
  }
  
  render() {
    let targetAttribute;
    if ( this.props.form_rule 
      && this.props.form_rule.target_attributes
      && this.props.form_rule.target_attributes.length === 1 ) {
      targetAttribute = this.props.form_rule.target_attributes[0];
    } else {
      console.warn('there should only be one target attribute');
    }
    const attributeValueArray = this.getEligbleFormAttributesForEditor();
    return (<div className="expression-editor-wrapper">
      <div className="content-editable-wrapper">
        <div className="alert alert-warning">
          This feature of building HTML with form rule is currently in BETA!
        </div>
        <div className="form-group">
          <label htmlFor="nocode_expression">HTML Content Editor</label>
          <textarea
            id={this.htmlEditorId}
            ref={this.textareaRef}
            className="form-control"
            name='form_rule[nocode_expression]'
            onChange={(event) => {this.updateTextarea(event)}}
            value={this.state.editorContent}
            rows="8" />
          <input type='hidden' name='form_rule[use_nocode_expression]' value="1" />
        </div>
      </div>
      <div className="row">
        <div className="col-6 embeddable-form-attributes-col">
          <h5><strong>FORM ATTRIBUTES</strong></h5>
          <div className="form-attributes-scroll-container">
          { 
            attributeValueArray.map( (variable, index) => {
              let displayLabel = variable.label;
              if (variable.display_type === "checkbox" || variable.form_attribute_display_type === "checkbox"){ // TODO: this is shit code
                displayLabel += " (sum of selected)";
              }
              return (<button type="button"
                key={index}
                className="btn btn-outline-info btn-block" 
                onClick={()=> {
                  this.addValueTypeToExpression(variable);
                } }><i className="fas fa-plus"></i> {displayLabel} ({variable.name})
              </button>);
            })
          }
          </div>
        </div>
        <div className="col-6 editor-notes-col">
        </div>
      </div>

      <hr />

      <div className="row">
        <label className="col-form-label col-sm-4">Format numbers for display</label>
        <div className="col-sm-8">
          <input type="hidden" name="form_rule[format_numbers_for_display]" value="0" />
          <input 
            type="checkbox"
            className="form-control"
            value="1"
            defaultChecked={this.props.form_rule.format_numbers_for_display}
            name="form_rule[format_numbers_for_display]" />
        </div>
      </div>

    </div>);
  }
}

export default HTMLExpressionEditor;